// CustomToggleButton.js
import React from 'react';
import MuiToggleButton from '@mui/material/ToggleButton';
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';

export const ToggleButton = styled(MuiToggleButton)(() => ({
    '&.Mui-selected, &.Mui-selected:hover': {
        color: '#fff',
        backgroundColor: '#062653 !important',
    },
    '&.MuiToggleButtonGroup-grouped': {
        color: '#393939',
        backgroundColor: '#transparent',
        border: '1px solid #062653!important',
        
    },

    '&.Mui-selected, ': {
        color: '#ecf1f8',
        backgroundColor: 'transparent',
    },
    '&.MuiToggleButton-root': {
        fontSize: '13px',
        fontFamily: 'Pretendard-R',
        padding: "4px 8px",
        width: 70,
        // backgroundColor: 'white',
        borderRadius: '4px 4px 4px 4px!important',
        border: '1px solid #F2F2F2!important',
        // color: 'white',
        // backgroundColor: '#4B5335',


    }
}));

export const ToggleButtonGroup = styled(MuiToggleButtonGroup)(({theme }) => ({
    '&.MuiToggleButtonGroup-root': {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        "& > *:not(:last-child)": {
            marginRight: theme.spacing(1)
        }
    }}));